import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import Grid from "@material-ui/core/Grid/Grid";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import MarketerToDos from "./user_components/MarketerToDos";
import MarketerOrders from "../orders/marketer_orders/MarketerOrders";
import AppCard from "../../components/layouts/components/AppCard";
import MarketerShops from "../shop/parts/MarketerShops";
import Details from "../user/components/Details";


class MarketerSummery extends React.Component {
    classes = this.props.classes;
    handleCopy(content){
        navigator.clipboard.writeText(content);
        this.props.enqueueSnackbar(Translate.marketerIdCopied, {
            variant: 'info',
        });
    }
    render(){
        let {user_id} = this.props;
        return (
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={ Translate.marketerSummery}
                        >
                            <MarketerToDos manage user_id={user_id}/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={ Translate.ordersList}
                        >
                            <MarketerOrders user_id={user_id}/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={ Translate.marketerShops}
                        >
                            <MarketerShops user_id={user_id}/>
                        </AppCard>
                    </Grid>
                    <Grid item xs={12}>
                        <AppCard
                            title={ Translate.userDetail}
                        >
                            <Details manage user_id={user_id}/>
                        </AppCard>
                    </Grid>
                </Grid>
        );
    }
}


export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(MarketerSummery))));
